export const name = 'sso-api-config'
export const api = {
  ding: {
    loginByCode: `/api/v2/bud/ding/login`, // get 通过code进行应用内登录
    getDingConfig: `/api/v2/bud/ding/config`, // get 获取钉钉appid
    getDingToken: `/api/v2/bud/login/ding/auto`, // get 获取钉钉Token
    getInviteParam: `/api/v2/bud/ding/organize/getInviteParam`, // get查询当前个人组织所在的主企业组织的cropId以及应用的appId
    getJurisdiction: `/api/v2/bud/menu/queryMenuForTree` // GET获取用户权限
  },
  workWechat: {
    getConfig: `/api/v2/bud/wechat/getConfig`, // get 获取企业微信config授权参数configParams
    getAgentConfig: `/api/v2/bud/wechat/getAgentConfig` // get 获取企业微信config授权参数configParams
  }
}
